module.exports = __webpack_public_path__ + "img/male-user.354e45af.png";